import {Component, HostBinding} from '@angular/core';

@Component({
  selector: 'homey-form-inputs',
  standalone: true,
  imports: [],
  templateUrl: './form-inputs.component.html',
  styleUrl: './form-inputs.component.scss'
})
export class FormInputsComponent {
  @HostBinding('class') class = 'flex flex-col gap-4 mb-4';
}
